import { Injectable } from "@angular/core";
import { HttpClient,HttpHeaders, HttpResponse} from '@angular/common/http';
import { Router } from "@angular/router";
import { ConfigService } from "@core/Abstract/config.service";
import { EventsEmitterService } from "@core/Abstract/emitter.service";
import { LogService } from "@core/Abstract/log.service";
import { SecurityService } from "@core/Security/security.service";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import * as FileSaver from "file-saver";
import { OnboardService } from "app/Menus/Onboard/onboard.service";

@Injectable()
export class VisualsService extends SecurityService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService
  ) {
    super(http, configService, eventsEmitterService, router, logger);
  }

  getVisuals(group: string, langId: string): Observable<any> {
    let serviceUrl =
      this.baseUrl +
      "VisualService/getVisuals?" +
      "group=" +
      group +
      "&langId=" +
      langId;
    return this.http.get(serviceUrl).pipe(
      map(super.extractData),
      catchError(super.handleError)
    );
  }

  getAllVisuals(langId: string): Observable<any> {
    let serviceUrl =
      this.baseUrl + "VisualService/getAllVisuals?" + "langId=" + langId;
    return this.http.get(serviceUrl).pipe(
      map(response => {
        let body = response;
        localStorage.setItem("visualsArray_" + langId, JSON.stringify(body));
        return body;
      }),
      catchError(super.handleError)
    );
  }

  getCurrencies(langId: string): Observable<any> {
    let serviceUrl = this.baseUrl + "UtilService/getCurrencies";

    return this.http.get(serviceUrl).pipe(
      map(response => {
        let body = response;
        localStorage.setItem("currencies_" + langId, JSON.stringify(body));
        return body;
      }),
      catchError(super.handleError)
    );
  }

  getLookup(table: string, column: string, langId: string): Observable<any> {
    let serviceUrl =
      this.baseUrl +
      "UtilService/getLookup?" +
      "param1=" +
      table +
      "&param2=" +
      column +
      "&param3=" +
      langId;
    return this.http.get(serviceUrl).pipe(
      map(response => {
        let body = response;
        this.setStorageLkp(table, column, langId, body);
        localStorage.setItem(
          "LKP_" + table + "_" + column + "_" + langId,
          JSON.stringify(body)
        );
        return body;
      }),
      catchError(super.handleError)
    );
  }

  getAllLookups(langId: string): Observable<any> {
    let serviceUrl =
      this.baseUrl + "UtilService/getAllLookups?" + "langId=" + langId;
    return this.http.get<any>(serviceUrl).pipe(
      map(response => {
        let body = response;

        let lkpCellRender = JSON.parse(
          localStorage.getItem("lkpCellRender" + langId)
        );

        let currentGroup = [];
        body.forEach(lkp => {
          // lkp.valLabel = this.customVisualReplace(lkp.valLabel, auth_rev == 'Y');
          lkpCellRender[lkp.lkupTable] = lkpCellRender[lkp.lkupTable]
            ? lkpCellRender[lkp.lkupTable]
            : {};
          lkpCellRender[lkp.lkupTable][lkp.lkupCol] = lkpCellRender[
            lkp.lkupTable
          ][lkp.lkupCol]
            ? lkpCellRender[lkp.lkupTable][lkp.lkupCol]
            : {};
          lkpCellRender[lkp.lkupTable][lkp.lkupCol][lkp.val] = lkp.valLabel;

          currentGroup = localStorage.getItem(
            "LKP_" + lkp.lkupTable + "_" + lkp.lkupCol + "_" + langId
          )
            ? JSON.parse(
                localStorage.getItem(
                  "LKP_" + lkp.lkupTable + "_" + lkp.lkupCol + "_" + langId
                )
              )
            : [];
          if ( currentGroup.findIndex(x => x.id === lkp.val) === -1 ) {
            currentGroup.push({ id: lkp.val, text: lkp.valLabel });
          }
          localStorage.setItem(
            "LKP_" + lkp.lkupTable + "_" + lkp.lkupCol + "_" + langId,
            JSON.stringify(currentGroup)
          );
        });

        localStorage.setItem(
          "lkpCellRender" + langId,
          JSON.stringify(lkpCellRender)
        );

        return body;
      }),
      catchError(super.handleError)
    );
  }

  getPaymentTypes(langId: string): Observable<any> {
    let serviceUrl =
      this.baseUrl + "VisualService/getPaymentTypes?" + "langId=" + langId;
    return this.http.get(serviceUrl).pipe(
      map(response => {
        let body = response;
        localStorage.setItem("paymenttypes_" + langId, JSON.stringify(body));
        return body;
      }),
      catchError(super.handleError)
    );
  }

  getDisapprCodes(langId: string): Observable<any> {
    let serviceUrl =
      this.baseUrl + "VisualService/getDisapprCodes?" + "langId=" + langId;
    return this.http.get(serviceUrl).pipe(
      map(response => {
        let body = response;
        localStorage.setItem("disapprcodes_" + langId, JSON.stringify(body));
        return body;
      }),
      catchError(super.handleError)
    );
  }

  getParam(key: string): Observable<any> {
    let serviceUrl =
      this.baseUrl + "UtilService/getParamValueByKey/?" + "key=" + key;
    return this.http.get(serviceUrl).pipe(
      map(super.extractData),
      catchError(super.handleError)
    );
  }

  public getLabelLookUpList(element, array: Array<JSON>): any {
    let pos = 0;

    array.forEach((item, index) => {
      if (item["id"] == element) pos = index;
    });

    return array[pos];
  }

  setStorageLkp(table: string, column: string, langId: string, array: any) {
    let lkpCellRender = JSON.parse(
      localStorage.getItem("lkpCellRender" + langId)
    );

    array.forEach(json => {
      lkpCellRender[table] = lkpCellRender[table] ? lkpCellRender[table] : {};
      lkpCellRender[table][column] = lkpCellRender[table][column]
        ? lkpCellRender[table][column]
        : {};
      lkpCellRender[table][column][json.id] = json.text;
    });

    localStorage.setItem(
      "lkpCellRender" + langId,
      JSON.stringify(lkpCellRender)
    );
  }

  
  downloadFile(id, name:string,userId): Observable<any> {
    var namex = name;                   
    let serviceUrl = this.baseUrl + "FileUploadService/downloadFile";
    
    return this.http.get(serviceUrl ,{ responseType: 'blob',params:{"userId":userId,"regcmpdocId":id}}).pipe(map((res)=>{ 
        let blob = new Blob([res], { type: res.type});
        FileSaver.saveAs(blob, namex);
    }));      
}

  previewFile(id: number, name: string, userId): Observable<Blob> {
    let serviceUrl = `${this.baseUrl}FileUploadService/downloadFile`;

    return this.http.get(serviceUrl, {
      params:{"userId":userId,"regcmpdocId":id},
      responseType: 'blob'
    });
  }
  
  downloadTemplateFile(hasTemplate: string ,templateFileName: string,templateFileExt: string, userId: string, docId: string):  Observable<any> {
    var namex = templateFileName + '.' + templateFileExt;
    let serviceUrl =  this.baseUrl + 'OnBoardService/getDocSamples?val='+ templateFileName +'&ext='+ templateFileExt+'&langId=2&regsecId=' + userId + '&docId=' + docId;
    return this.http.get(serviceUrl,{ responseType: 'blob', observe: 'response'})
    .pipe(map(function(res){ 
        let blob = new Blob([res.body], { type: res.body.type});
        FileSaver.saveAs(blob, namex);
    })
    ,catchError(error => super.handleBlobError(error)));   
  }

  deleteFile(regcmpdocId: any): Observable<any> {
    let options:Object = { responseType: 'text' }
    let serviceUrl = this.baseUrl + "FileUploadService/deleteFile";
    return this.http.post<any>(serviceUrl,regcmpdocId, options).pipe(map(response => {return response;}));
  }
}
